import { render } from "./flashcards_player.vue?vue&type=template&id=49042076"
import script from "./flashcards_player.vue?vue&type=script&lang=js"
export * from "./flashcards_player.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__